
import { useLocation } from 'react-router-dom';
import { SEOHead } from './SEOHead';
import { StructuredData } from './StructuredData';
import { useSEO } from '@/hooks/use-seo';
import { getPageSEOData } from '@/utils/seoUtils';

export const SEOManager: React.FC = () => {
  const location = useLocation();
  const seoData = getPageSEOData(location.pathname);
  
  // Use the SEO hook for additional functionality
  useSEO({
    title: seoData.title,
    description: seoData.description,
    keywords: seoData.keywords,
    type: seoData.type
  });

  return (
    <>
      <SEOHead
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type={seoData.type}
        url={`${window.location.origin}${location.pathname}`}
      />
      
      <StructuredData type="organization" />
      <StructuredData type="breadcrumb" />
      
      {/* Add service-specific structured data for service pages */}
      {location.pathname.startsWith('/services') && (
        <StructuredData 
          type="service" 
          data={{
            name: "Services Médicaux",
            description: "Services de téléconsultation et soins médicaux"
          }}
        />
      )}
    </>
  );
};
